import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
 fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
 toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
 filterModel: null,
 quickFilterText: "",
};

const slice = createSlice({
 name: "subconAdvance",
 initialState,
 reducers: {
 setDates: (state, { payload }) => {
 state.fromDate = payload.fromDate;
 state.toDate = payload.toDate;
 },
 setFilterModel: (state, { payload }) => {
 state.filterModel = payload;
 },
 setQuickFilterText: (state, { payload }) => {
 state.quickFilterText = payload;
 },
 resetSubconAdvanceState: () => initialState,
 },
});

export const {
 setDates,
 setFilterModel,
 setQuickFilterText,
 resetSubconAdvanceState,
} = slice.actions;

export default slice.reducer;